export default __webpack_public_path__ + "static/media/celebration.2986079e.svg";